<fieldset class="sps-fieldset form-data-container">
  <div class="grid w-full">
    @if (!activationResult.successful) {
      <div class="col-12 flex flex-column gap-2">
        <p-message severity="error" icon="pi pi-exclamation-triangle" styleClass="w-full mb-3">
          <div [innerHTML]="activationErrorMessage | safeHtml"></div>
        </p-message>
      </div>
    } @else {
      <div class="col-12 flex flex-column">
        <div class="text-lg font-bold mb-1">Shop</div>
        <p-table [value]="shopResultData"
                 [scrollable]="true">
          <ng-template pTemplate="body" let-data>
            <tr>
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
                  [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
                  [colSpan]="data?.titleColspan ? 2 : 1"
                  [width]="titleColumnWidth">
                {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
              </td>
              <!-- TODO implement needed value-types -->
              @if (!data?.titleColspan) {
                @switch (data?.valueType) {
                  @case ('MULTILINE') {
                    <td class="overflow-hidden text-overflow-ellipsis line-height-3"
                        [style]="{'white-space': 'pre-line', 'min-width': '160px'}"
                        [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                        [width]="valueColumnWidth">
                      {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                    </td>
                  }
                  @default {
                    <td class="overflow-hidden text-overflow-ellipsis"
                        [style]="{'min-width': '160px'}"
                        [ngStyle]="{'white-space': (layoutService.isMobile() ? 'nowrap !important': 'normal !important')}"
                        [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                        [width]="valueColumnWidth">
                      {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                    </td>
                  }
                }
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-12 flex flex-column mt-3">
        <div class="text-lg font-bold mb-1">{{ i18n.i18nLng()['CONTRACT'] }}</div>
        <p-table [value]="contractResultData"
                 [scrollable]="true">
          <ng-template pTemplate="body" let-data>
            <tr>
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
                  [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
                  [colSpan]="data?.titleColspan ? 2 : 1"
                  [width]="titleColumnWidth">
                {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
              </td>
              <!-- TODO implement needed value-types -->
              @if (!data?.titleColspan) {
                @switch (data?.valueType) {
                  @case ('MULTILINE') {
                    <td class="overflow-hidden text-overflow-ellipsis line-height-3"
                        [style]="{'white-space': 'pre-line', 'min-width': '160px'}"
                        [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                        [width]="valueColumnWidth">
                      {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                    </td>
                  }
                  @default {
                    <td class="overflow-hidden text-overflow-ellipsis"
                        [style]="{'min-width': '160px'}"
                        [ngStyle]="{'white-space': (layoutService.isMobile() ? 'nowrap !important': 'normal !important')}"
                        [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                        [width]="valueColumnWidth">
                      {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
                    </td>
                  }
                }
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
</fieldset>
